import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, Loading, LoadingController } from 'ionic-angular';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../providers/auth/auth';
import { HomePage } from '../home/home';
import { FirebaseDatabase } from 'angularfire2';
import { AngularFireDatabase } from 'angularfire2/database';
import { RoulettePage } from '../roulette/roulette';

/**
 * Generated class for the RegisterPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-register',
  templateUrl: 'register.html',
})
export class RegisterPage {
  registerForm: FormGroup;
  loading: Loading;

  constructor(public navCtrl: NavController, private fbDB: AngularFireDatabase, private auth: AuthService, public navParams: NavParams, private formBuider: FormBuilder, private tCtrl: ToastController, private loadingCtrl: LoadingController) {
    this.registerForm = this.formBuider.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      name: ['', Validators.required],
      company: ['', Validators.required],
      secret: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ionViewDidLoad() {
    this.registerForm = this.formBuider.group({
      email: ['', Validators.compose([Validators.required, Validators.email])],
      name: ['', Validators.required],
      company: ['', Validators.required],
      secret: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  register() {
    this.loading = this.loadingCtrl.create({
    });
    this.loading.present();
    let registerValues = this.registerForm.value;
    this.registerForm.markAsTouched();
    if(this.registerForm.valid) {
      if(registerValues.secret != "cyberlunch") {
        let toast = this.tCtrl.create({
          message: "Geheimcode ist ungültig",
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.loading.dismiss();
        this.registerForm.get('secret').setErrors({'incorrect': true});
      } else {
        let credentials = {
          email: registerValues.email,
          password: registerValues.password
        };
        this.auth.signUp(credentials).then((response) => {
          let userUID = response.user.uid;
          //create user in firebase:
          let userNode = {
            email: registerValues.email,
            name: registerValues.name,
            company: registerValues.company
          }
          this.fbDB.database.ref("users").child(userUID).set(userNode).then(() => {
            let toast = this.tCtrl.create({
              message: "Registrierung erfolgreich, sie werden gleich angemeldet...",
              duration: 3000,
              position: 'top'
            });
            toast.onDidDismiss(() => {
              this.navCtrl.setRoot(RoulettePage);
            })
            toast.present();
            this.loading.dismiss();
          });
        }).catch((error) => {
          let toast = this.tCtrl.create({
            message: "Fehler bei Registrierung aufgetreten.",
            duration: 3000,
            position: 'top'
          });
          toast.present();
          this.loading.dismiss();
        });
      }
    } else {
      let toast = this.tCtrl.create({
        message: "Bitte überprüfen Sie Ihre Eingaben.",
        duration: 3000,
        position: 'top'
      });
      toast.present();
      this.loading.dismiss();
    }
  }

  back(){
    this.navCtrl.popToRoot();
  }

}



// WEBPACK FOOTER //
// ./src/pages/register/register.ts